module.exports = __webpack_public_path__ + "media/images/payments/neteller-dark-0d7f439ea81a7dc1b7e2e153b89209d1.svg";